/**
 * @file theme.js
 * @description Defines the application's Material-UI theme configuration.
 * This file contains the global styling settings, color palette, and component
 * customizations used throughout the application.
 */

import { Height } from "@mui/icons-material";
import { createTheme } from "@mui/material/styles";

/**
 * Application theme configuration
 * @type {Object}
 */
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#000000", // Black
    },
    secondary: {
      main: "#FFFFFF", // White
    },
    text: {
      primary: "#000000",
      secondary: "#000000",
    },
    lightBlackBg: {
      main: "#333333",
    },
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        // Global scrollbar styling
        body: {
          "&::-webkit-scrollbar": {
            width: "8px !important",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: `${theme.palette.primary.main} !important`,
            borderRadius: "10px !important",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: theme.palette.primary.main,
          },
        },
        // Drawer component scrollbar styling
        "& .MuiDrawer-paper": {
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
          },
        },
        // Popover component scrollbar styling
        "& .MuiPopover-paper": {
          "&::-webkit-scrollbar": {
            width: "8px !important",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: `${theme.palette.primary.main} !important`,
            borderRadius: "10px !important",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: theme.palette.primary.main,
          },
        },
        // Table container scrollbar styling
        "& .MuiTableContainer-root": {
          "&::-webkit-scrollbar": {
            width: "6px !important",
            height: "6px !important", // For horizontal scrollbar
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#333333",
            borderRadius: "10px !important",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
        },
      }),
    },
  },
});

export default theme;
